export var MuiSvgIcon = {
    styleOverrides: {
        root: {
            height: 'auto',
            width: 'auto',
        },
    },
};
